import {Injectable} from '@angular/core';
import {APIRequest, APIRequestResources, PaginationResponse} from "../../../../../../core";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {BehaviorSubject, Subject, tap} from "rxjs";
import {toSignal} from "@angular/core/rxjs-interop";
import {SalesOrderFindNewDTO, SalesOrderGetNewDTO} from "../../interface/sales-order/sales-order-new.entity";

@Injectable({
    providedIn: 'root'
})
export class SalesOrderNewService extends APIRequest {

    private readonly $all = new BehaviorSubject<SalesOrderFindNewDTO[]>([]);
    all = toSignal(this.$all, {initialValue: []})

    private readonly $active = new BehaviorSubject<SalesOrderGetNewDTO | undefined>(undefined);
    active = toSignal(this.$active, {initialValue: undefined})

    private salesOrderCreated = new Subject<void>();

    constructor(protected override http: HttpClient, private router: Router) {
        super(http, APIRequestResources.SalesOrderService)
    }

    find = (searchParams: any, refresh = true) => {
        return this.get<PaginationResponse<SalesOrderFindNewDTO[]>>({
            endpoint: `find`,
            params: searchParams,
        }).pipe();
    }

    pushedToNikeTracker = (salesOrderId: number
    ) => {
        return this.get<any>({
            endpoint: `nike/${salesOrderId}`,
        })
    }


    getById = (id: any, refresh = false) => {
        return this.get<SalesOrderGetNewDTO>({id})
            .pipe(
                tap((res) => this.$active.next(res.data)),
            );
    }

    create = (salesOrder: any) => {
        return this.post<any>(salesOrder, {})
    }

    update = (salesOrderId: number, salesOrderDetail: any) => {
        const options = {suffix: salesOrderId.toString()};
        return this.patch<any>(salesOrderDetail, options);
    }

    isPoExist = (po_number: string, customer_id: number
    ) => {
        return this.get<any>({
            endpoint: `exist`, params: {po_number: po_number, customer_id: customer_id,},
        })
    }

    notifySalesOrderCreated() {
        this.salesOrderCreated.next();
    }

    onSalesOrderCreated() {
        return this.salesOrderCreated.asObservable();
    }

    initial = () => {
        this.$active.next(undefined)
    }

}
